<template>
	<VueApexChart
		v-if="chartOptions"
		class="app-chart-stacked-bar"
		:class="{ 'live' : autoUpdate }"
		ref="chart"
		height="100%"
		width="100%"
		type="bar"
		:options="chartOptions"
		:series="series"
	/>
</template>

<script>
export default {
	props: {
		title: [String, Array],
		tickAmount: {
			type: Number,
			default: 5
		},

		autoUpdate: {
			type: Boolean,
			default: false
		},
		labels: {
			type: Array,
			required: true
		},
		series: {
			type: Array,
			default: () => []
		},

		noData: {
			type: String,
			default: 'No Data'
		}
	},

	watch: {
		labels (newVal, oldVal) {
			if (JSON.stringify(newVal) !== JSON.stringify(oldVal)) {
				this.init()
			}
		}
	},

	created () {
		this.$watch(vm => [
			vm.autoUpdate,
			vm.title,
			vm.noData
		], () => {
			this.init()
		})

		this.init()
	},

	data () {
		return {
			chartOptions: null
		}
	},

	methods: {
		init () {
			let maxData = this.tickAmount
			if (this.series.length) {
				const data = this.series.reduce((data, series) => (data = [...data, ...series.data]), [])
				maxData = Math.max(...data)
			}

			this.chartOptions = {
				chart: {
					stacked: true,
					toolbar: {
						show: false
					}
				},
				stroke: { width: 1 },
				colors: ['#5FE3A1', '#56D9FE', '#A3A1FB'],
				dataLabels: { enabled: false },
				fill: { opacity: 0.6 },
				yaxis: {
					tickAmount: this.tickAmount,
					min: 0,
					max: maxData,
					labels: {
						formatter: val => val.toFixed(0)
					}
				},
				xaxis: {
					categories: this.labels,
					tickPlacement: 'between',
					labels: {
						style: {
							fontSize: '10px'
						}
					}
				},
				title: {
					text: this.title,
					margin: 0,
					style: {
						color: 'currentColor',
						fontWeight: 'normal',
						fontSize: '11px'
					}
				},
				grid: {
					show: true,
					borderColor: '#eee',
					xaxis: { lines: { show: true } }
				},
				legend: {
					position: 'bottom',
					horizontalAlign: 'center',
					fontSize: '10px',
					itemMargin: { horizontal: 10 },
					markers: {
						radius: 5,
						width: 18,
						height: 10
					},
					onItemHover: { highlightDataSeries: !this.autoUpdate },
					onItemClick: { toggleDataSeries: !this.autoUpdate }
				},
				tooltip: {
					enabled: !this.autoUpdate,
					style: { fontSize: '9px' },
					marker: { show: false }
				},
				noData: {
					text: this.noData,
					align: 'center',
					verticalAlign: 'middle',
					style: { fontSize: '10px' }
				}
			}
		}
	}
}
</script>

<style lang="scss" scoped>
.app-chart-stacked-bar {
	text-transform: capitalize;
	&.live { pointer-events: none; }
}
</style>



// WEBPACK FOOTER //
// src/components/app-components/AppChartStackedBar.vue